export const MODOS = [
  { key: 'horas',    label: 'Por horas'   },
  { key: '7dias',    label: '7 días'      },
  { key: '30dias',   label: '30 días'     },
  { key: 'dia',      label: 'Por día'     },
  { key: 'mes',      label: 'Por mes'     },
  { key: 'año',      label: 'Por año'     },
];

export const MESES = ['Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.',
                'Jul.', 'Ago.', 'Sep.', 'Oct.', 'Nov.', 'Dic.'];
